import React, { Component, Fragment } from 'react';
import { Icon, Layout, Row, Col, Card } from 'antd';
import { Link } from 'react-router-dom';
import { find, propEq, omit } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import { project_application_edit } from 'constants/routes';
import Breakpoint from 'components/layout/Breakpoint.js';
import BackButton from 'components/common/elements/BackButton';
import { getProjects, getApplications, getDistributors, getUser } from 'actions/asyncActions';
import ApplicationSpecTable from './ApplicationSpecTable';
import {formatMoney} from 'utils/ramdaAdditions.js';

import ApplicationChat from './ApplicationChat'; 
import { RenderDistributorInfo } from './RenderDistributorInfo';
import ApplicationForm from './ApplicationForm';

@withAsyncActions({
    getProjects: getProjects.withOptions({ dispatchOnMount: true }),
    getDistributors: getDistributors.withOptions({ dispatchOnMount: true }),
    getApplications: getApplications
        .withPayload(({ match: { params } }) => params.project_id)
        .withOptions({ dispatchOnMount: true }),
    getUser,
})


export default class ProjectApplicationView extends Component {

    state = {
        isOpen: false
    }

    changeDistribotor = () => {
        this.setState({ isOpen: !this.state.isOpen})
    }

    renderHeader(project, application) {
        const applicationEditLink = project_application_edit.stringify({
            project_id: project.id,
            id: application.id
        });

        return (
            <Fragment>
                <Breakpoint min="sm">
                    <Row type="flex" align="top" className="m-b-30" justify="space-between">
                        <Row type="flex" align="top">
                                <BackButton />
                                <div className="application-title title-route m-l-30">
                                    <span>Проект: {project.name}</span>
                                    <span className="color-link">Заявка: {application.name}</span>
                                    <div className="color-title weight-bold m-t-10">ID заявки: {application.id}</div>
                                </div>
                        </Row>
                        <Link className="title-link" to={applicationEditLink}>
                            <Icon type="edit" />  Редактировать
                        </Link>
                    </Row>
                </Breakpoint>
                <Breakpoint max="sm">
                    <Row className="xs-p-20 m-b-30" type="flex" align="middle" justify="space-between">
                        <BackButton />
                        <Link className="title-link" to={applicationEditLink}>
                            <Icon type="edit" />  Редактировать
                        </Link>
                    </Row>
                    <div className="application-title title-route xs-p-20">
                        <span>Проект: {project.name}</span>
                        <span className="color-link">Заявка: {application.name}</span>
                        <div className="color-title weight-bold m-t-10">ID заявки: {application.id}</div>
                    </div>
                </Breakpoint>
            </Fragment>
        );
    }

    render() {
        const { project_id, id } = this.props.match.params;
        const { data: { applications = [] } } = this.props.getApplications;
        const { data: { projects = [] } } = this.props.getProjects;
        const distributors = this.props.getDistributors.data; 

        const project = find(propEq('id', Number(project_id)), projects);
        const application = find(propEq('id', Number(id)), applications);
        const distributor = application && distributors && find(propEq('id', Number(application.distributor_id)), distributors)
        const shop = distributor && distributor.active_shops.find(shop=> shop.id === application.shop_id);

        return !project || !application || !distributor || !shop ? null : (
            <Fragment>
                <Layout className="project container page md-970 sm-720 page-sm-no-m main-content">
                    {this.renderHeader(project, application)}
                    <div className="m-t-30">
                        <div className="project-title xs-p-20">Описание проекта</div>
                        <div className="application-view-description">
                            <div className="md-480 xs-p-20">
                                <p className="project-description">
                                    {project.description}
                                </p>
                            </div>
                            <Card className="card-covered xs-fullwidth" title="Контактное лицо:" cover={<Icon type="user" />} bordered={false}>
                                <p className="card-content card-content-bold">
                                    <b>{application.contact_surname} {application.contact_name} {application.contact_patronymic}</b><br />
                                    {application.contact_email}<br />
                                    {application.contact_phone}
                                </p>
                            </Card>
                        </div>
                    </div>
                    <Row gutter={30} className="xs-p-20">
                        <Col md={12} sm={24}>
                            <div className="project-title">Выбранный дистрибьютор</div>
                        </Col>
                    </Row>
                    <RenderDistributorInfo 
                        distributor= {distributor}
                        shop={shop}
                        status_price={application.status_price}
                        changeDistribotor={this.changeDistribotor}
                    />
                    
                    { this.state.isOpen ?
                        <ApplicationForm
                            changelocation={{ location: shop.city.toLowerCase() }}
                            isEdit={true}
                            project_id={project_id}
                            application_id={application.id}
                            initialValues={{
                                ...omit(['files'], application),
                                files: application.files.map(file => file.id),
                            }}
                            {...this.props}
                        /> : null
                    }

                    <Row gutter={30} className="xs-p-20">
                        <Col md={12} sm={24}>
                            <div className="project-title">Cashback</div>
                        </Col>
                    </Row>

                    <div className="application-view-cards xs-fullwidth">
                        <Card title="Выплаченный Cashback:" bordered={false} className="card-covered">
                            <span className="counters">
                                {formatMoney(application.paid_cashback && application.price ? application.price : 0)}
                            </span>
                        </Card>
                        <Card title="Планируемый Cashback:" bordered={false} className="card-covered">
                            <span className="counters">
                                {formatMoney(!application.paid_cashback && application.price ? application.price : 0)}
                            </span>
                        </Card>
                    </div>

                    <Row gutter={30} className="xs-p-20">
                        <Col md={12} sm={24}>
                            <div className="project-title">Материалы</div>
                        </Col>
                    </Row>

                    <ApplicationSpecTable
                        project={project}
                        application={application}
                        onAccept={() => {this.props.getApplications.refresh();}}
                    />
                    <ApplicationChat appId={id} />
                </Layout>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/application/ProjectApplicationView.js